import { Directive, TemplateRef, input } from '@angular/core';
import { IHasTableConfig } from '../pagination-table-config';

export declare class PaginationTableColumnDisplayDirectiveContext<T = unknown> {
	$implicit: T;
	rowId: number;
	alternateViewActive?: boolean;
}

@Directive({
	selector: 'ng-template[aePgtDisplay]',
})
export class PaginationTableColumnDisplayDirective<T = unknown> {
	readonly aePgtDisplay = input<IHasTableConfig<T, any>>();
	readonly cellClass = input<string>();

	constructor(
		public template: TemplateRef<
			PaginationTableColumnDisplayDirectiveContext<T>
		>,
	) {}

	static ngTemplateGuard_aePgtDisplay: 'binding';
	static ngTemplateContextGuard<T>(
		_dir: PaginationTableColumnDisplayDirective<T>,
		_ctx: any,
	): _ctx is PaginationTableColumnDisplayDirectiveContext<T> {
		return true;
	}
}
